module.exports = __webpack_public_path__ + "static/img/60.596a800.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/60.png
// module id = wd1U
// module chunks = 1